import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"
import { cn } from "@/lib/utils"

/** UI.md §4/§6: white, hairline border, 8 px radius; focus = brand border plus a brand-soft halo. */
const fieldClasses =
  "w-full min-w-0 rounded-md border border-border bg-input-bg px-2.5 text-body text-foreground transition-colors duration-150 outline-none placeholder:text-subtle-foreground hover:border-border-strong focus-visible:border-brand focus-visible:ring-3 focus-visible:ring-brand-soft disabled:cursor-not-allowed disabled:bg-sunken disabled:text-muted-foreground read-only:bg-sunken/40 aria-invalid:border-negative"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        fieldClasses,
        "h-8 py-1 file:mr-2 file:border-0 file:bg-transparent file:text-label file:font-medium file:text-foreground",
        className
      )}
      {...props}
    />
  )
}

export { Input, fieldClasses }
